import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const Disclaimer = ({ data }) => {
  const i18n = useContext(I18nContext);
  const disclaimerName = data?.Name || '';
  const disclaimerText = disclaimerName.length > 0 ? i18n.getString(_TL_('{{disclaimerName}}'), { disclaimerName }) : i18n.getString(_TL_('No disclaimer selected'));

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Disclaimers') }}>
      <Text>{disclaimerText}</Text>
    </PropertyRow>
  );
};

Disclaimer.propTypes = {
  data: PropTypes.shape({
    Name: PropTypes.string,
  }),
};

Disclaimer.defaultProps = {
  data: {
    Name: '',
  },
};
